// extracted by mini-css-extract-plugin
module.exports = {"NumericRangeFeature":"wo_a bhv_b bhv_ux"};